<template>
    <async-btn
            :task="task"
            label="Remove from Timeline"
            v-bind="$attrs"
            @click="remove"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import notify from '@/components/notify';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { removeFromTimeline } from '../post';

interface Data {
  task: Promise<Post>|null,
}

export default defineComponent({
  components: { AsyncBtn },
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    remove() {
      this.task = removeFromTimeline(this.postId);
      this.task.then(() => {
        notify('Post removed from timeline.');
      });
    },
  },
});
</script>
